__turbopack_context__.v({
  "imgContainer": "index-module-scss-module__9FsW4W__imgContainer",
});
